import { ChangeEvent, useState } from "react";
import { Icon } from "customer-portal-ui-component-library";
import { alpha, InputBase, styled } from "@mui/material";

const SearchWrapper = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  fontSize: 17,
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "12ch",
      "&:focus": {
        width: "20ch",
      },
    },
  },
}));

interface SearchProps {
  outline?: boolean;
  handleSearch: (event: ChangeEvent<HTMLInputElement>) => void;
  filterElement?: string; // New prop to specify the class name of elements to filter
}

export const Search = ({ handleSearch, filterElement }: SearchProps) => {
  const [searchQuery, setSearchQuery] = useState<string>("");

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(event.target.value);
    handleSearch(event);
  };

  return (
    <>
      <SearchWrapper>
        <SearchIconWrapper>
          <Icon name='magnifying-glass' variant='light' fontSize='small' />
        </SearchIconWrapper>
        <StyledInputBase
          placeholder="Search…"
          inputProps={{
            "aria-label": "search",
            value: searchQuery,
            onChange: handleChange,
          }}
        />
      </SearchWrapper>
    </>
  );
};
